module.exports = __webpack_public_path__ + "img/weibo.57188625.png";